module.exports = __webpack_public_path__ + "img/pencil-circle.6dd26375.svg";